export default __webpack_public_path__ + "static/media/hollowStar.85026bca.svg";